import React, { useEffect, useState, useContext } from 'react'
import DataTable from 'react-data-table-component';
import NotifyService from '../Services/Notify.service'
import DataContext from "../data/DataContext";
import Swal from 'sweetalert2'

function NotifyTelegram() {
    const notifyService = new NotifyService()
    const dataConf = useContext(DataContext)
    const [dataNotify, setDataNotify] = useState()
    const [dataNotifyFull, setDataNotifyFull] = useState()

    const [notify, setNotify] = useState()

    useEffect(() => {
        fetchDataNotify()
    }, [])

    const fetchDataNotify = () => {
        dataConf.blockUI()
        notifyService.listing().then((result) => {
            dataConf.blockUI()
            if (result.success) {
                setDataNotify(result.data)
                setDataNotifyFull(result.data)
            } else {
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#890000',
                })
            }
        })
    }

    const filterDataNotify = (e) => {
        const filter = e.target.value
        if (filter !== '') {
            const data = dataNotifyFull
            const dataFilter = data.filter((noti, i) => {
                return noti.noti_line_name.toLowerCase().includes(filter.toLowerCase())
            })
            setDataNotify(dataFilter)
        } else {
            setDataNotify(dataNotifyFull)
        }

    }

    const getDataNotify = (_id) => {
        dataConf.blockUI()
        notifyService.getting({ p_noti_id: _id }).then((result) => {
            dataConf.blockUI()
            if (result.success) {
                setNotify(result.data)
            } else {
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#890000',
                })
            }
        })
    }

    const createDataNotify = (e) => {
        e.preventDefault()
        const tlg_name = e.target.e_telegram_name.value
        const tlg_key = e.target.e_telegram_token.value
        const cht_id = e.target.e_chat_id.value
        const payload = {
            p_noti_line_name: tlg_name,
            p_noti_telegram_token: tlg_key,
            p_noti_telegram_chat_id: cht_id
        }
        dataConf.blockUI()
        notifyService.creating(payload).then((result) => {
            dataConf.blockUI()
            if (result.success) {
                fetchDataNotify()
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'success',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: 'green',
                })
            } else {
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#890000',
                })
            }
        })
    }

    const delDataNotify = (_id) => {

        Swal.fire({
            title: 'ยืนยัน',
            text: 'คุณต้องการลบรายการแจ้งเตือนนี้หรือไม่',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'ยืนยัน',
            confirmButtonColor: '#890000',
            cancelButtonText: 'ยกเลิก',
        }).then((result) => {
            if (result.isConfirmed) {
                dataConf.blockUI()
                notifyService.deleting({ p_noti_id: _id }).then((result) => {
                    dataConf.blockUI()
                    if (result.success) {
                        fetchDataNotify()
                    } else {
                        Swal.fire({
                            title: result.message,
                            text: '',
                            icon: 'warning',
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: '#890000',
                        })
                    }
                })
            }
        })
    }


    return (
        <div className="container pt-3">
            <h4>แจ้งเตือน</h4>
            <hr />
            <div className="row">
                <div className="col-sm-4">
                    <div className="card mb-2">
                        <div className="card-body">
                            <form onSubmit={createDataNotify}>
                                <div className="mb-3">
                                    <label className="form-label">ชื่อกลุ่มเทเลแกรม</label>
                                    <input type="text" className="form-control form-control-sm" id="e_telegram_name" placeholder="กรอกชื่อกลุ่มเทเลแกรม" required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">เทเลแกรมโทเค็น</label>
                                    <input type="text" className="form-control form-control-sm" id="e_telegram_token" placeholder="กรอกเทเลแกรมโทเค็น" required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">ไอดีกลุ่มเทเลแกรม</label>
                                    <input type="text" className="form-control form-control-sm" id="e_chat_id" placeholder="กรอก ไอดีกลุ่มเทเลแกรม" required />
                                </div>
                                <button type="submit" className="btn btn-warning btn-sm">สร้างรายการแจ้งเตือน</button>
                                <button type="reset" className="btn btn-light ms-2 btn-sm">ล้างข้อมูล</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-sm-8">
                    <div className="card">
                        <div className="card-body px-0">
                            <div>
                                <div className=" mb-1 col-sm-4 float-end me-2">
                                    <input type="text" className="form-control form-control-sm" placeholder="ค้นหา" onChange={filterDataNotify} />
                                </div>
                            </div>
                            <DataTable
                                columns={[
                                    {
                                        name: 'ชื่อกลุ่ม',
                                        width: '25%',
                                        selector: row => row.noti_line_name,
                                    },
                                    {
                                        name: 'Token',
                                        width: '25%',
                                        selector: row => row.noti_telegram_token,
                                    },
                                    {
                                        name: 'Chat ID',
                                        width: '25%',
                                        selector: row => row.noti_telegram_chat_id,
                                    },
                                    {
                                        name: '',
                                        // width:'20%',
                                        selector: row => {
                                            return (
                                                <>
                                                    <button className="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#update-notify" onClick={() => { getDataNotify(row.noti_id) }}>แก้ไข</button>
                                                    <button className="btn btn-sm btn-danger ms-1" onClick={() => { delDataNotify(row.noti_id) }}>ลบ</button>
                                                </>
                                            )
                                        },
                                    },
                                ]}
                                data={dataNotify}
                                selectableRows
                                pagination
                                noDataComponent="ไม่พบรายการข้อมูล"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <UpdateNotify notify={notify} fetchDataNotify={fetchDataNotify} />
        </div>
    )
}

export default NotifyTelegram


function UpdateNotify(props) {
    const notifyService = new NotifyService()
    const dataConf = useContext(DataContext)

    const noti = props.notify
    const updateNoti = (e) => {
        e.preventDefault()
        const _id = e.target.e_noti_id.value
        const tlg_name = e.target.e_telegram_name.value
        const tlg_key = e.target.e_telegram_token.value
        const cht_id = e.target.e_chat_id.value
        const payload = {
            p_noti_id: _id,
            // p_noti_line_name: tlg_name,
            p_noti_telegram_token: tlg_key,
            p_noti_telegram_chat_id: cht_id
        }
        dataConf.blockUI()
        notifyService.updating(payload).then((result) => {
            dataConf.blockUI()
            if (result.success) {
                props.fetchDataNotify()
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'success',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: 'green',
                })
            } else {
                Swal.fire({
                    title: result.message,
                    text: '',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#890000',
                })
            }
        })
    }
    return (
        <div className="modal fade" id="update-notify" tabIndex={-1} aria-labelledby="notifyModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="notifyModalLabel">แก้ไขข้อมูลการแจ้งเตือน</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <form onSubmit={updateNoti}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">ชื่อกลุ่มเทเลแกรม</label>
                                <input type="text" className="d-none" id="e_noti_id" defaultValue={noti ? noti.noti_id : ''} />
                                <input type="text" className="form-control form-control-sm" id="e_telegram_name" placeholder="กรอกชื่อกลุ่มเทเลแกรม" defaultValue={noti ? noti.noti_line_name : ''} readOnly disabled />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">เทเลแกรมโทเค็น</label>
                                <input type="text" className="form-control form-control-sm" id="e_telegram_token" placeholder="กรอกเทเลแกรมโทเค็น" defaultValue={noti ? noti.noti_telegram_token : ''} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ไอดีกลุ่มเทเลแกรม</label>
                                <input type="text" className="form-control form-control-sm" id="e_chat_id" placeholder="กรอก ไอดีกลุ่มเทเลแกรม" defaultValue={noti ? noti.noti_telegram_chat_id : ''} required />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-sm btn-success float-end">บันทึกข้อมูล</button>
                            <button type="reset" className="btn btn-sm btn-secondary float-start" data-bs-dismiss="modal">ปิด</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}